<template>
    <div>
      <designBulletinAnalyseReport-list></designBulletinAnalyseReport-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  